var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2529 18.8284C10.4914 18.8284 9.04297 20.2768 9.04297 22.0383C9.04297 23.7999 10.4914 25.2483 12.2529 25.2483C14.0145 25.2483 15.4629 23.7999 15.4629 22.0383C15.4629 20.2768 14.0145 18.8284 12.2529 18.8284V18.8284Z",
    fill: "#0078BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7857 18.8284C30.0241 18.8284 28.5757 20.2768 28.5757 22.0383C28.5757 23.7999 30.0241 25.2483 31.7857 25.2483C33.5472 25.2483 34.9956 23.7999 34.9956 22.0383C34.9956 20.2768 33.5472 18.8284 31.7857 18.8284V18.8284Z",
    fill: "#0078BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.61922C31.5907 4.61922 39.3808 12.4093 39.3808 22C39.3808 31.5907 31.5907 39.3808 22 39.3808C12.4093 39.3808 4.61922 31.5907 4.61922 22C4.61922 12.4093 12.4093 4.61922 22 4.61922ZM22 0C9.86477 0 0 9.86477 0 22C0 34.1352 9.86477 44 22 44C34.1352 44 44 34.1352 44 22C44 9.86477 34.1744 0 22 0Z",
    fill: "#0078BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1534 1.33203H19.8865V12.058H24.1534V1.33203Z",
    fill: "#0078BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1534 32.6482H19.8865V42.7087H24.1534V32.6482Z",
    fill: "#0078BA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocket);
export default __webpack_public_path__ + "static/media/socket.fb2b3d7c0e468e6012b98a38dd001f2b.svg";
export { ForwardRef as ReactComponent };